import { render } from "./TicketIssuingAnimation.vue?vue&type=template&id=4b9c12c4&scoped=true"
import script from "./TicketIssuingAnimation.vue?vue&type=script&lang=js"
export * from "./TicketIssuingAnimation.vue?vue&type=script&lang=js"

import "./TicketIssuingAnimation.vue?vue&type=style&index=0&id=4b9c12c4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9c12c4"]])

export default __exports__